import React from 'react';

import { IconCloseSmall, IconGlobe, Stack, TextField, TextFieldButton } from '@lessonnine/design-system.lib';
import { t } from 'src/viewLayer/helpers/translations';

export default ({
  clearValue,
  disabled,
  errorKey,
  isFocused,
  onChangeHandler,
  value
}) => (
  <Stack className="InputFrame" gap={16}>
    <TextField
      actionButton={
        value ?
          <TextFieldButton
            onClick={ () => clearValue() }
            icon={ <IconCloseSmall /> }
            title={ 'Clear' }
          />
          : null
      }
      autoComplete="subdomain"
      autoFocus={ isFocused }
      additionalText={ errorKey && t(errorKey) }
      data-testid="identityprovider-input-field"
      disabled={ disabled }
      fullWidth={ true }
      icon={ <IconGlobe/> }
      id="uat-identityprovider-input-field"
      onChange={ onChangeHandler }
      placeholder={ t('login.b2b.identity_provider_placeholder') }
      prefilledText=".babbel.com"
      state={ errorKey ? 'error' : 'default' }
      type="text"
      value={ value }
    />
  </Stack>
);

